export default __webpack_public_path__ + "locales/sr-Latn-RS/InviteDialog.json?hash=d6dde735f18297aa240b6464b5086111";